export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.91f9f2e6.woff";